import { post } from "./utils/request";
import cookies from "js-cookie";

export const getLoginStatus = function (currRoute) {
    return new Promise(function (resolve, reject) {
        console.log(currRoute);
        // if(currRoute.isWxLogin === false) {
        if (!currRoute.isGongYing) {
            resolve();
        } else {
            const url = "/gateway/manageBadrock/wechatcs/getUserByOpenid";
            post({
                url,
                data: {},
            }).then(
                (res) => {
                    console.log(444444, res);
                    if (res.result === "success") {
                        let data;
                        try {
                            data = JSON.parse(res.data);
                        } catch (err) {
                            data = res.data;
                        }
                        cookies.set("accountName", data.accountName);
                        cookies.set("supplierName", data.supplierName);
                        resolve();
                    } else {
                        reject();
                    }
                },
                () => {
                    reject();
                }
            );
        }
    });
};



// WEBPACK FOOTER //
// ./src/service.js